import React from 'react';
import Header from './Header';
import photo1 from 'assets/images/photo-1.jpg';
import photo2 from 'assets/images/photo-2.jpg';
import photo3 from 'assets/images/photo-3.jpg';
import photo4 from 'assets/images/photo-4.jpg';
import photo5 from 'assets/images/photo-5.jpg';
import photo6 from 'assets/images/photo-6.jpg';
import photo7 from 'assets/images/photo-7.jpg';
import photo8 from 'assets/images/photo-8.jpg';
import photo9 from 'assets/images/photo-9.jpg';

import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Group>
          <img src={photo1} alt="Vestido, Louis Vuitton" />
          <S.Legend>Vestido, Louis Vuitton</S.Legend>
        </S.Group>
        <S.Group>
          <img src={photo2} alt="Vestido, The Attico para NK" />
          <S.Legend>Vestido, The Attico para NK</S.Legend>
        </S.Group>
      </S.Content>
      <S.Content>
        <S.Group>
          <img src={photo3} alt="Photo3" />
          <S.Legend> </S.Legend>
        </S.Group>
        <S.Group>
          <img src={photo4} alt="Blazer, Dolce & Gabbana" />
          <S.Legend>Blazer, Dolce & Gabbana</S.Legend>
        </S.Group>
      </S.Content>
      <S.Content>
        <S.Group>
          <img src={photo5} alt="Jaqueta, Dolce & Gabbana" />
          <S.Legend>Jaqueta, Dolce & Gabbana</S.Legend>
        </S.Group>
        <S.Group>
          <img src={photo6} alt="Vestido, The Attico para NK" />
          <S.Legend>Vestido, The Attico para NK</S.Legend>
        </S.Group>
      </S.Content>
      <S.Content>
        <S.Group>
          <img src={photo7} alt="Camisa, GinGin" />
          <S.Legend>Camisa, GinGin</S.Legend>
        </S.Group>
        <S.Group>
          <img src={photo8} alt="Photo8" />
          <S.Legend> </S.Legend>
        </S.Group>
      </S.Content>
      <S.Content>
        <S.Group>
          <img src={photo9} alt="Photo9" />
          <S.Legend> </S.Legend>
        </S.Group>
        <S.Credits>
          <article>
            <h2>CRÉDITOS</h2>
            Modelos: Mayumi Ishihara, Lucas Antunes, Michelle Dantas, Ariela
            Soares e Ellen Schiessl
            <br />
            Assistente de moda: Gabriela Vargas
            <br />
            Assistente de moda: Felipe Gomes
            <br />
            Camareira: Egle Doxum
            <br />
            Assistente de foto: Naelson de Castro
            <br />
            Assistente de foto: Aline Lins
            <br />
            Assistente de beleza: Felipe Cavalcanti
            <br />
            Assistente de beleza: Juliana Gonçalves
            <br />
            Assistente de beleza: Cristian Dalle
            <br />
            Manicure: Thayna Dandara e Sandra Goretti
            <br />
            Produção executiva: Isabela de Paula
            <br />
            Assist. Produção executiva: Deise Cruz e Carlos Henrique
            <br />
            Contrarregra: Ronaldo Junge
            <br />
            Tratamento de imagem: Thiago Auge
            <br />
          </article>
        </S.Credits>
      </S.Content>
    </S.Container>
  );
};

export default Main;
